import React from 'react';
import { AlertBanner, AlertBannerTypes } from '../../Components/AlertBanner';
import { useMedicationSettings } from '../../Config/MedicationConfig';
import styles from './ScopeOfPracticeBanner.module.css';
export var ScopeOfPracticeBanner = function () {
    var _a, _b;
    var medicationSettings = useMedicationSettings();
    return (React.createElement("span", { className: styles.regular },
        React.createElement(AlertBanner, { promptType: AlertBannerTypes.Warn, promptExtraInfo: "This medication falls outside your scope of practice. You will need a " + ((_b = (_a = medicationSettings.settings.verbalOrderTerm) === null || _a === void 0 ? void 0 : _a.singularTerm) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase()) + " from an authorised prescriber.", verticalSpace: true })));
};
